import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1bee08fa"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=1bee08fa&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports